export enum PermissionType {
  Security = 'Security',
  Application = 'Application'
}
